import { gql } from "@apollo/client";

export const CREATE_BAP = gql`
    mutation CreateEvaluacionBAP($input: AddEvaluacionBAPInput!, $idEvaluacion: Int!)
    {
        createEvaluacionBAP(input: $input, idEvaluacion: $idEvaluacion) 
        {
            idEvaluacionBAP
            idEvaluacion
        }
    }
`;